import { render, staticRenderFns } from "./EmptyData.vue?vue&type=template&id=40fddc4e&scoped=true"
import script from "./EmptyData.vue?vue&type=script&lang=js"
export * from "./EmptyData.vue?vue&type=script&lang=js"
import style0 from "./EmptyData.vue?vue&type=style&index=0&id=40fddc4e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40fddc4e",
  null
  
)

export default component.exports